import { TnplShippingPolicy } from "@redotech/redo-tnpl-settings-common/tnpl-settings";
import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import * as z from "zod";

export const TnplContractTemplateSchema = z.object({
  _id: zExt.objectId().meta({ privacy: privacy.id.internal }),
  team: zExt.objectId().meta({ privacy: privacy.id.internal }),
  name: z.string().min(1).meta({ privacy: privacy.resourceLabel }),
  description: z.string().optional().meta({ privacy: privacy.text.merchant }),
  trialPeriodDays: z
    .number()
    .min(0)
    .optional()
    .meta({ privacy: privacy.quantity }),
  trialPeriodHours: z
    .number()
    .min(0)
    .optional()
    .meta({ privacy: privacy.quantity }),
  trialPeriodMinutes: z
    .number()
    .min(0)
    .optional()
    .meta({ privacy: privacy.quantity }),
  trialEndChargeDelayDays: z
    .number()
    .min(0)
    .optional()
    .meta({ privacy: privacy.quantity }),
  trialEndChargeDelayHours: z
    .number()
    .min(0)
    .optional()
    .meta({ privacy: privacy.quantity }),
  trialEndChargeDelayMinutes: z
    .number()
    .min(0)
    .optional()
    .meta({ privacy: privacy.quantity }),
  merchantProcessingDays: z
    .number()
    .min(0)
    .optional()
    .default(10)
    .meta({ privacy: privacy.quantity }),
  productIds: z
    .array(z.number().meta({ privacy: privacy.id.external.resource }))
    .meta({ privacy: privacy.structured }),
  sellingPlanId: z
    .number()
    .nullish()
    .meta({ privacy: privacy.id.external.resource }),
  sellingPlanGroupId: z
    .number()
    .nullish()
    .meta({ privacy: privacy.id.external.resource }),
  emailSubjectLine: z
    .string()
    .optional()
    .meta({ privacy: privacy.text.merchant }),
  cartValueLimit: z.number().min(0).optional().meta({ privacy: privacy.money }),
  cartMaxTnplItems: z
    .number()
    .min(0)
    .optional()
    .meta({ privacy: privacy.quantity }),
  shippingPolicy: z
    .custom<TnplShippingPolicy>()
    .meta({ annotation: "String", privacy: privacy.untypedPayload })
    .optional(),
  createdAt: z.date().meta({ privacy: privacy.timestamp }),
  updatedAt: z.date().meta({ privacy: privacy.timestamp }),
});

export type TnplContractTemplate = z.infer<typeof TnplContractTemplateSchema>;
export interface ITnplContractTemplate extends z.ZodType<TnplContractTemplate> {}

export type TnplContractTemplateInAutoCheck = Pick<
  TnplContractTemplate,
  | "trialPeriodDays"
  | "trialPeriodMinutes"
  | "cartValueLimit"
  | "cartMaxTnplItems"
>;
